import { createFileRoute } from "@tanstack/react-router";
import { InvitePage } from "../screens/invite/InvitePage.tsx";

/**
 * `/invite#<token>`: the page behind an invitation's link (PLAN §7.15, Team). The token stays in the address's
 * #fragment and travels in an Authorization header, so no server log sees it; it is the proof, so the request needs no
 * CSRF token. The page signs the person in right here, the same ways as log in (`useSignInMethods`), fixed to the
 * invited address, and every way comes back to this page. Signed in as that address, it joins by itself and opens the
 * company's Home; signed in as another, it says so and offers the right one. The API refuses any other address.
 */
export const Route = createFileRoute("/invite")({
  component: InvitePage,
});
